import heart from "../assets/heart.png";

/**
 * Unread count, drawn inside the hand-drawn heart from the Homecoming artwork.
 *
 * The PNG is used as a CSS mask rather than an <img>, so the brush shape stays
 * exactly as designed while the colour comes from CSS — the artwork is a pale
 * outline, and on the black pass it needs to be gold.
 *
 * Renders nothing at zero: an empty badge is just noise.
 */
export default function NotifyHeart({ count }) {
  if (!count) return null;

  // Past 9 the number stops fitting inside the heart's opening.
  const label = count > 9 ? "9+" : String(count);

  return (
    // A span, not a button: the pass itself is the button, and nesting one
    // inside another is invalid and unreachable by keyboard.
    <span className="notify-heart" role="status" aria-label={`${count} unread`}>
      <span
        className="nh-shape"
        style={{ WebkitMaskImage: `url(${heart})`, maskImage: `url(${heart})` }}
        aria-hidden="true"
      />
      <span className={"nh-count" + (label.length > 1 ? " nh-wide" : "")}>{label}</span>
    </span>
  );
}
